import React, { useState } from 'react'
import { inviteUser } from '../../api/inviteUser'
import { ROLES } from '../../lib/roles'

export default function InviteUser() {
  const [email, setEmail] = useState('')
  const [role, setRole] = useState('')

  const [sending, setSending] = useState(false)
  const [message, setMessage] = useState<{ ok: boolean; text: string } | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (sending) return
    const cleanEmail = email.trim()
    if (!cleanEmail) return setMessage({ ok: false, text: 'Please enter an email address.' })
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(cleanEmail)) return setMessage({ ok: false, text: 'That email address does not look valid.' })
    if (!role) return setMessage({ ok: false, text: 'Please select a role.' })
    setSending(true)
    setMessage(null)
    const { error } = await inviteUser({ email: cleanEmail, role })
    setSending(false)
    if (error) return setMessage({ ok: false, text: error })
    setMessage({ ok: true, text: `Invitation sent to ${cleanEmail}` })
    setEmail('')
    setRole('')
  }

  return (
    <div className="container mx-auto py-8 max-w-md">
      <h1 className="text-2xl font-bold mb-6">Invite User</h1>
      <form onSubmit={handleSubmit} noValidate className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
          >
            <option value="">Select a role</option>
            {ROLES.map(r => <option key={r} value={r}>{r.charAt(0) + r.slice(1).toLowerCase()}</option>)}
          </select>
        </div>
        {message && (
          <p className={message.ok ? 'text-sm text-green-700' : 'text-sm text-red-700'}>{message.text}</p>
        )}
        <button
          type="submit"
          disabled={sending}
          className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {sending ? 'Sending…' : 'Send Invitation'}
        </button>
      </form>
    </div>
  )
}
